import { render, staticRenderFns } from "./RegistrableConference.vue?vue&type=template&id=4708f2d9&scoped=true"
import script from "./RegistrableConference.vue?vue&type=script&lang=js"
export * from "./RegistrableConference.vue?vue&type=script&lang=js"
import style0 from "./RegistrableConference.vue?vue&type=style&index=0&id=4708f2d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4708f2d9",
  null
  
)

export default component.exports